import { useGetQuery } from "hooks";
import { Card, Center, Logo, Text, Title, Wrapper } from "components";

const formatDate = (iso) => {
  return new Date(iso).toLocaleDateString([], {
    weekday: "short",
    month: "short",
    day: "numeric",
  });
};

const isToday = (iso) =>
  new Date(iso).toDateString() === new Date().toDateString();

export const HolidaysList = () => {
  const { data, isFetching } = useGetQuery({ url: "/holidays?limit=50" });
  const holidays = data?.events?.rows || [];

  return (
    <Card>
      <Wrapper margin="2rem 0 0.5rem">
        <Center>
          <Logo width="150" height="150" />
        </Center>
      </Wrapper>
      <Wrapper margin="0.5rem">
        <Title level={3} color="link">
          Holidays
        </Title>
      </Wrapper>
      {isFetching && (
        <Wrapper margin="0.5rem">
          <Text>Loading...</Text>
        </Wrapper>
      )}
      {!isFetching && holidays.length === 0 && (
        <Wrapper margin="0.5rem">
          <Text>No upcoming holidays.</Text>
        </Wrapper>
      )}
      {holidays.map((holiday) => (
        <Wrapper
          key={holiday.id}
          margin="0.4rem 0.5rem"
          css="display:flex;justify-content:space-between;gap:1rem;"
        >
          <Text>{holiday.name}</Text>
          <Text color={isToday(holiday.start_time) ? "link" : "text"}>
            {isToday(holiday.start_time)
              ? "Today"
              : formatDate(holiday.start_time)}
          </Text>
        </Wrapper>
      ))}
    </Card>
  );
};
